/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BookingStrictHttpResponse } from '../../booking-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicalAdvisorBookingDetailModel } from '../../models/medical-advisor-booking-detail-model';

export interface ApiMedicalAdvisorBookingDetailUrnBookingIdGet$Params {
  urnBookingId: string;
}

export function apiMedicalAdvisorBookingDetailUrnBookingIdGet(http: HttpClient, rootUrl: string, params: ApiMedicalAdvisorBookingDetailUrnBookingIdGet$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<MedicalAdvisorBookingDetailModel>> {
  const rb = new RequestBuilder(rootUrl, apiMedicalAdvisorBookingDetailUrnBookingIdGet.PATH, 'get');
  if (params) {
    rb.path('urnBookingId', params.urnBookingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BookingStrictHttpResponse<MedicalAdvisorBookingDetailModel>;
    })
  );
}

apiMedicalAdvisorBookingDetailUrnBookingIdGet.PATH = '/api/MedicalAdvisor/BookingDetail/{urnBookingId}';
